import { Component } from '@angular/core';
import { GoogleLoginCfgService } from './googleLoginCfg.service';

declare const google: any;

@Component({
    selector: 'google-login',
    templateUrl: './googleLogin.component.html',
    styleUrls: ['./googleLogin.component.css'],
    standalone: false
})
export class GoogleLoginComponent {
  private clientId = "";
  private redirectUri = "";
  private googleScope = "";

  constructor(private googleLoginCfgService: GoogleLoginCfgService) {
    this.clientId = this.googleLoginCfgService.getCfg().googleAccount;
    this.redirectUri = this.googleLoginCfgService.getCfg().redirectUri;
    this.googleScope = this.googleLoginCfgService.getCfg().googleScope;
  }

  async ngOnInit() {
    google.accounts.id.initialize({
      client_id: this.clientId,
      callback: (resp: any) =>
        this.handleCredentialResponse(resp),
    });
    google.accounts.id.renderButton(
      document.getElementById("googleLoginBtn"), { theme: "outline", size: "large" }
    );
    google.accounts.id.prompt();
  }

  /**
   * Manejo de las credenciales de google
   * @param response Respuesta de las credenciales de google
   */
  handleCredentialResponse(response: any) {
    if (!response || !response.credential) return;

    const tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: this.clientId,
      scope: this.googleScope,
      ux_mode: 'redirect',
      redirect_uri: this.redirectUri,
      callback: (tokenResponse: any) => {
        if (!tokenResponse.access_token || tokenResponse.error) {
          alert('Ocurrió un problema al ingresar.');
          return;
        }

        localStorage.setItem('googleAuth', JSON.stringify({
          clientId: response.clientId,
          select_by: response.select_by,
          id_token: response.credential,
          access_token: tokenResponse.access_token,
          hd: tokenResponse.hd
        }));

        window.location.href = this.redirectUri;
      },
      error_callback: (error: any) => {
        alert('Ocurrió un problema al intentar iniciar sesión. Verifique que su navegador permite la apertura de ventanas emergentes (pop-ups) e inténtelo de nuevo.');
      }
    });

    tokenClient.requestAccessToken();
  }
}
